import React from 'react';
import { Alert, Fade } from '@mui/material';
import { useLogin } from '../hooks/useLogin';

export const LoginAlerts = () => {
  const { error, isLocked, getRemainingTime } = useLogin();

  return (
    <>
      {error && (
        <Fade in timeout={500}>
          <Alert
            severity="error"
            sx={{
              width: '100%',
              mb: 2,
              bgcolor: 'rgba(211, 47, 47, 0.1)',
              '& .MuiAlert-icon': {
                color: '#ff4444',
              },
            }}
          >
            {error}
          </Alert>
        </Fade>
      )}
      {isLocked && (
        <Fade in timeout={500}>
          <Alert
            severity="warning"
            sx={{
              width: '100%',
              mb: 2,
              bgcolor: 'rgba(255, 152, 0, 0.1)',
              '& .MuiAlert-icon': {
                color: '#ff9800',
              },
            }}
          >
            Аккаунт заблокирован{getRemainingTime()}
          </Alert>
        </Fade>
      )}
    </>
  );
}; 